@import "../../variables.scss";

$color-label-grey: rgba(0, 0, 0, 0.5);
$color-odd-table-cell-grey: #f2f4f6;
$color-table-border-grey: #dcdcdc;
$color-day-sum-dark-grey: #cbd1dc;
$color-btn-edit: #495057;
.timesheet {
  @media (max-width: $size-md) {
    overflow-x: hidden;
    padding: 1rem;
  }
  h2 {
    margin-top: 1.5rem;
    button {
      margin-left: 2rem;
    }
  }

  table {
    border: none;

    tr {

      td:not(:first-child) {
        border-bottom: 1px solid $color-table-border-grey;
      }

    }

    tbody {
      td:first-child {
        span {
          white-space: nowrap;
        }
      }

      tr:not(:last-child) {
        td:nth-child(even) {
          background-color: $color-odd-table-cell-grey;
        }
      }

      tr:nth-last-child(2) {
        border-bottom: none;
      }

      tr:last-child {
        border-bottom: none;

        td:not(:first-child) {
          background-color: $color-day-sum-dark-grey;
          border-right: 1px solid $color-table-border-grey;
        }
      }
    }

    th {
      font-size: 1rem;
      padding: 0.5rem 1rem;
      white-space: nowrap;
      font-weight: normal;
    }

    td {
      padding: 1rem;
    }
  }
}

.blueOutline {
  border-color: #2196f3;
}

.btnEdit {
  background-color: $color-btn-edit;
  color: white;

  &:hover {
    color: $color-btn-edit;
  }
}

.label {
  color: $color-label-grey;
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: 700;
  display: inline-block;
  width: 80px;
}

.timesheet__actions {
  @media (max-width: 991px) {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    height: 100px;
    background: white;
    padding: 2rem;
    z-index: 1;
    .timesheet__edit {
      padding-left: 0;
    }
  }
}

.timesheet__notification {
  width: 100%;
  height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &_title {
    margin-top: 30px;
    text-align: center;
  }

  &_subtitle {
    text-align: center;
    white-space: pre-line;
  }

  &_overviewButton {
    text-align: center;
    margin-top: 15px;
    margin-bottom: 15px;

    &_wrapper {
      width: 660px;
      display: flex;
      justify-content: flex-end;
      flex-shrink: 0;
      @media (max-width: $size-md) {
        width: 510px;
      }
      @media (max-width: $size-sm) {
        width: 100%;
        margin-right: 1rem;
      }
    }
  }
}

.timesheet__saveBorder {
  background-color: $color-grey;
  height: 1px;
  width: 100%;
}

.timesheet__saveButton {
  width: calc(100% + 2rem);
  margin-left: -1rem;
  margin-right: -1rem;
}

.timesheet__saveChanges {
  color: $color-btn-edit;
  border: 1px solid #f60;
  &:hover {
    color: $color-btn-edit;
  }
  &:disabled {
    color: $color-btn-edit;
  }
}

.timesheet__back {
  color: $color-btn-edit;
  border: 1px solid rgb(0, 64, 255);
}

.timesheet__infoBox {
  padding: 1rem;
  border-radius: 12px;
  background-color: rgba(68, 136, 255, 0.05);
  font-family: Lato;
  font-size: 16px;
  letter-spacing: 0.3px;
  line-height: 19px;
  width: 700px;
}

.timesheet__infoBox_mobile {
  padding: 1rem;
  border-radius: 12px;
  background-color: rgba(68, 136, 255, 0.05);
  width: calc(100% + 2rem);
  margin-left: -1rem;
  font-family: Lato;
  font-size: 12px;
  letter-spacing: 0.23px;
  line-height: 15px;
}

.timesheet__loader {
  height: 75vh;
}

@media (max-width: $size-md) {
  .timesheet__notification_titleMobile {
    text-transform: capitalize;
  }
}
